import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";

import type {IConsentTemplate} from "../types";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export const ConsentFileLink = ({template, className}: IProps) => {
    if (!template.file || !template.file_link_text) {
        return null;
    }

    return (
        <Link size="x-small" underline href={template.file} target="_blank" rel="noopener noreferrer" className={className ?? link}>
            {template.file_link_text}
        </Link>
    );
};

const link = css({
    display: "block",
    width: "100%",
    textAlign: "center"
});
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";

import type {IConsentTemplate} from "../types";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export const ConsentFileLink = ({template, className}: IProps) => {
    if (!template.file || !template.file_link_text) {
        return null;
    }

    return (
        <Link size="x-small" underline href={template.file} target="_blank" rel="noopener noreferrer" className={className ?? link}>
            {template.file_link_text}
        </Link>
    );
};

const link = css({
    display: "block",
    width: "100%",
    textAlign: "center"
});
